import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Flex from '@client/components/flex/Flex';
import ReactLink from '@client/components/links/reactLink/ReactLink';
import { getMainRoutes } from '@client/shared/utils/routerUtils/routerUtils';
import allerLogo from '@client/shared/images/landingPageAssets/aller-logo-black.svg';
import sparksLogo from '@client/shared/images/logo-white.png';
import playStore from '@client/shared/images/landingPageAssets/playstore_blackwhite.png';
import appStore from '@client/shared/images/landingPageAssets/appstore_blackwhite.png';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './landingFooter.scss';

const MAIN_ROUTES = getMainRoutes();

const LandingFooter = ({ showAdvertiserLogin }) => {
  const { t, i18n } = useTranslation(['footer', 'common']);

  const isEnglishLanguage = i18n.language === 'en';
  return (
    <section className={styles.footer}>
      <div
        className={classNames(
          styleHelper.landingPageSectionContent,
          styles.contentContainer
        )}
      >
        <Flex className={styles.logoAndLinksContainer}>
          <ReactLink to={'/'}>
            <img
              src={sparksLogo}
              alt={'Sparks logo'}
              className={styles.sparksLogo}
            />
          </ReactLink>
          <Flex column className={styles.menuItems}>
            {showAdvertiserLogin && (
              <ReactLink
                className={styles.menuItem}
                to={MAIN_ROUTES.ADVERTISER_LOGIN.TO}
              >
                <span className={styleHelper.landingFooterLink}>
                  {t('footer:login')}
                </span>
              </ReactLink>
            )}
            <ReactLink
              className={styles.menuItem}
              to={MAIN_ROUTES.ADVERTISER.TO}
            >
              <span className={styleHelper.landingFooterLink}>
                {t('footer:advertiser')}
              </span>
            </ReactLink>
            <ReactLink className={styles.menuItem} to={MAIN_ROUTES.FAQ.TO}>
              <span className={styleHelper.landingFooterLink}>
                {t('footer:faq')}
              </span>
            </ReactLink>
            {isEnglishLanguage ? (
              <a className={styles.menuItem} href={'/fi/terms'}>
                <span className={styleHelper.landingFooterLink}>
                  {t('footer:terms')}
                </span>
              </a>
            ) : (
              <ReactLink className={styles.menuItem} to={MAIN_ROUTES.TERMS.TO}>
                <span className={styleHelper.landingFooterLink}>
                  {t('footer:terms')}
                </span>
              </ReactLink>
            )}
          </Flex>
        </Flex>
        <Flex
          className={classNames(styleHelper.mgt32, styles.storeIconsContainer)}
        >
          <a
            className={styles.icon}
            href={t('common:appStoreLink')}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={appStore} alt={'Apple store'} />
          </a>
          <a
            className={styles.icon}
            href={t('common:playStoreLink')}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={playStore} alt={'Google Play store'} />
          </a>
        </Flex>
        <Flex className={styles.termsAndAllerLogo}>
          <h5
            className={classNames(
              styleHelper.landingDefaultText,
              styles.policyText
            )}
          >
            {`ALLER MEDIA® ${new Date().getFullYear()} - `}
            <a
              className={classNames(
                styleHelper.landingDefaultText,
                styles.policyText
              )}
              href={`${t('footer:privacyPolicyURL')}`}
            >
              {t('footer:privacyPolicyAndCookies')}
            </a>
            {` - ${t('footer:customerService')}: `}
            <a
              className={classNames(
                styleHelper.landingDefaultText,
                styles.policyText
              )}
              href="mailto:hello@allersparks.com"
            >
              hello@allersparks.com
            </a>
          </h5>
          <a
            className={styles.allerLink}
            href={t('common:allerLink')}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={allerLogo} alt="" className={styles.allerMediaLogo} />
          </a>
        </Flex>
      </div>
    </section>
  );
};

LandingFooter.propTypes = {
  showAdvertiserLogin: PropTypes.bool,
};

export default LandingFooter;
